/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetAllInventoryItemsParams,
  FleetInventoryItem,
  FleetInventoryItemCreateInput,
  FleetInventoryItemUpdateInput,
  FleetInventoryItemsList,
  FleetInventoryItemsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet Inventory Item
 */
export const createFleetInventoryItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    fleetInventoryItemCreateInput: MaybeRefOrGetter<FleetInventoryItemCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
fleetInventoryItemCreateInput = toValue(fleetInventoryItemCreateInput);

      return axiosClient<FleetInventoryItem>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetInventoryItemCreateInput, signal
    },
      );
    }




export const getCreateFleetInventoryItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;data: FleetInventoryItemCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;data: FleetInventoryItemCreateInput}, TContext> => {

const mutationKey = ['createFleetInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetInventoryItem>>, {fleetSlug: string;fleetInventorySlug: string;data: FleetInventoryItemCreateInput}> = (props) => {
          const {fleetSlug,fleetInventorySlug,data} = props ?? {};

          return  createFleetInventoryItem(fleetSlug,fleetInventorySlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetInventoryItem>>>
    export type CreateFleetInventoryItemMutationBody = FleetInventoryItemCreateInput
    export type CreateFleetInventoryItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Fleet Inventory Item
 */
export const useCreateFleetInventoryItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;data: FleetInventoryItemCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetInventoryItem>>,
        TError,
        {fleetSlug: string;fleetInventorySlug: string;data: FleetInventoryItemCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Inventory Items List
 */
export const fleetInventoryItems = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
params = toValue(params);

      return axiosClient<FleetInventoryItemsList>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInventoryItemsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>,) => {
    return [
    'fleets',fleetSlug,'inventories',fleetInventorySlug,'items', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryItemsQueryKey(fleetSlug,fleetInventorySlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryItems>>> = ({ signal }) => fleetInventoryItems(fleetSlug,fleetInventorySlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetInventorySlug) !== null && toValue(fleetInventorySlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>
}

export type FleetInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryItems>>>
export type FleetInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Items List
 */

export function useFleetInventoryItems<TData = Awaited<ReturnType<typeof fleetInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryItemsQueryOptions(fleetSlug,fleetInventorySlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Fleet Inventory Item
 */
export const destroyFleetInventoryItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetInventoryItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string}, TContext> => {

const mutationKey = ['destroyFleetInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetInventoryItem>>, {fleetSlug: string;fleetInventorySlug: string;id: string}> = (props) => {
          const {fleetSlug,fleetInventorySlug,id} = props ?? {};

          return  destroyFleetInventoryItem(fleetSlug,fleetInventorySlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetInventoryItem>>>

    export type DestroyFleetInventoryItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Fleet Inventory Item
 */
export const useDestroyFleetInventoryItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetInventoryItem>>,
        TError,
        {fleetSlug: string;fleetInventorySlug: string;id: string},
        TContext
      > => {
      return useMutation(getDestroyFleetInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Fleet Inventory Item
 */
export const updateFleetInventoryItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetInventorySlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetInventoryItemUpdateInput: MaybeRefOrGetter<FleetInventoryItemUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetInventorySlug = toValue(fleetInventorySlug);
id = toValue(id);
fleetInventoryItemUpdateInput = toValue(fleetInventoryItemUpdateInput);

      return axiosClient<FleetInventoryItem>(
      {url: `/fleets/${fleetSlug}/inventories/${fleetInventorySlug}/items/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetInventoryItemUpdateInput, signal
    },
      );
    }




export const getUpdateFleetInventoryItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string;data: FleetInventoryItemUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string;data: FleetInventoryItemUpdateInput}, TContext> => {

const mutationKey = ['updateFleetInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetInventoryItem>>, {fleetSlug: string;fleetInventorySlug: string;id: string;data: FleetInventoryItemUpdateInput}> = (props) => {
          const {fleetSlug,fleetInventorySlug,id,data} = props ?? {};

          return  updateFleetInventoryItem(fleetSlug,fleetInventorySlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetInventoryItem>>>
    export type UpdateFleetInventoryItemMutationBody = FleetInventoryItemUpdateInput
    export type UpdateFleetInventoryItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Fleet Inventory Item
 */
export const useUpdateFleetInventoryItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetInventoryItem>>, TError,{fleetSlug: string;fleetInventorySlug: string;id: string;data: FleetInventoryItemUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetInventoryItem>>,
        TError,
        {fleetSlug: string;fleetInventorySlug: string;id: string;data: FleetInventoryItemUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet All Inventory Items
 */
export const fleetAllInventoryItems = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAllInventoryItemsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetInventoryItemsList>(
      {url: `/fleets/${fleetSlug}/inventory-items`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetAllInventoryItemsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAllInventoryItemsParams>,) => {
    return [
    'fleets',fleetSlug,'inventory-items', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetAllInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof fleetAllInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAllInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetAllInventoryItemsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetAllInventoryItems>>> = ({ signal }) => fleetAllInventoryItems(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryItems>>, TError, TData>
}

export type FleetAllInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetAllInventoryItems>>>
export type FleetAllInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet All Inventory Items
 */

export function useFleetAllInventoryItems<TData = Awaited<ReturnType<typeof fleetAllInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetAllInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetAllInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetAllInventoryItemsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






